import { BACKEND_HOST } from "@/api";

export const LEGAL_CONTENT = {
  "service-policy": {
    titleKey: "service_policy_title",
    contentKey: "service_policy_content",
    fallbackTitle: "서비스 이용약관",
    legacyUrl: `${BACKEND_HOST}/service-policy/`,
  },
  "privacy-policy": {
    titleKey: "privacy_policy_title",
    contentKey: "privacy_policy_content",
    fallbackTitle: "개인정보처리방침",
    legacyUrl: "https://www.amazingticket.site/agree.html",
  },
} as const;

export type LegalKind = keyof typeof LEGAL_CONTENT;

export const hasLegalDocumentContent = (
  kind: LegalKind,
  siteDetail: Record<string, unknown> | null | undefined
) => {
  const content = siteDetail?.[LEGAL_CONTENT[kind].contentKey];
  return typeof content === "string" && content.trim().length > 0;
};

export const getLegalDocumentHref = (
  kind: LegalKind,
  siteDetail: Record<string, unknown> | null | undefined
) => {
  if (hasLegalDocumentContent(kind, siteDetail)) {
    return `/legal/${kind}`;
  }
  return LEGAL_CONTENT[kind].legacyUrl;
};

export const isExternalLegalHref = (href: string) => /^https?:\/\//.test(href);
